
import SizeGuide from "~/components/blocks/SizeGuide.vue";
import UiIcon from "~/components/UI/UiIcon.vue";
import UiSpinner from "~/components/UI/UiSpinner.vue";

export default {
  name: "SizeGuideDrawer",
  components: {
    SizeGuide,
    UiIcon,
    UiSpinner,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    sizeGuideUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      sizeGuideData: null,
      previousOverflow: "",
    };
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          this.getSizeGuideData();
        }

        if (!process.client) return;

        if (val) {
          this.previousOverflow =
            document.body.style.overflow ||
            getComputedStyle(document.body).overflow ||
            "";

          if (this.previousOverflow !== "hidden") {
            document.body.style.overflow = "hidden";
          }
        } else {
          document.body.style.overflow = this.previousOverflow || "";
        }
      },
      immediate: true,
    },
  },
  computed: {
    isOpen: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    sizeGuideContent() {
      return this.sizeGuideData?.mixedTranslation?.content;
    },
  },
  methods: {
    async getSizeGuideData() {
      if (this.sizeGuideData) return;
      this.loading = true;
      try {
        const { data } = await this.$api.pages.getBlok("size-guide-ring");
        this.sizeGuideData = data.data;
      } catch (err) {
        console.log("err - ", err?.response?.data?.errors);
      } finally {
        this.loading = false;
      }
    },
  },
};
